<template lang="html">
  <div class="">
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            Bulletin Subscribers
            <v-spacer />
            <v-btn
              color="primary"
              depressed
              @click="exportToCsv"
            >
              Export
            </v-btn>
          </v-card-title>
          <v-list three-line>
            <div
              v-for="(subscriber, i) in subscribers"
              :key="subscriber.id"
            >
              <v-list-item>
                <v-list-item-avatar
                  :color="subscriber.color"
                  class="white--text ml-n1"
                >
                  {{ _initials(subscriber.name) }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ subscriber.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ subscriber.company }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-layout
                      mt-1
                      wrap
                    >
                      <v-flex
                        xs12
                        md4
                      >
                        <div class="">
                          <div class="caption">
                            Email:
                          </div>
                          <a
                            class="grey--text text--darken-4 text-decoration-none"
                            :href="`mailto:${subscriber.email}`"
                          >{{ subscriber.email }}</a>
                        </div>
                        <div>
                          <div class="caption mt-2">
                            Phone:
                          </div>
                          <a
                            class="grey--text text--darken-4 text-decoration-none"
                            :href="`tex:${subscriber.phone}`"
                          >{{ subscriber.phone }}</a>
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                      >
                        <v-layout ma-0>
                          <v-flex pa-0>
                            <div class="caption">
                              Address:
                            </div>
                            <div class="grey--text text--darken-4">
                              {{ subscriber.address1 }}
                            </div>
                            <div class="grey--text text--darken-4">
                              {{ subscriber.address2 }}
                            </div>
                            <div class="grey--text text--darken-4">
                              {{ subscriber.city }}, {{ subscriber.province }} {{ subscriber.postcode }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                      >
                        <div class="caption">
                          Source:
                        </div>
                        <div class="grey--text text--darken-4">
                          {{ subscriber.source }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>
                    <!-- {{ date(subscriber.timestamp) }} -->
                    <SiDeleteButton
                      :message="`Are you sure you want to delete this subscriber ${subscriber.name}?`"
                      @delete="deleteSubscriber(subscriber)"
                    />
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="i < (subscribers || []).length -1"
              />
            </div>
            <template v-if="(subscribers || []).length === 0 && !_loader ">
              <v-list-item>
                <v-list-item-title class="grey--text font-italic">
                  No subscribers contacts to show...
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach, sortBy } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import moment from 'moment'
import helpers from '@/mixins/helpers'
import durations from '@/mixins/durations'
import binder from '@/mixins/binder'
import seen from '@/mixins/seen'
import { parse } from 'json2csv'
// import colors from 'vuetify/lib/util/colors'

export default {
  mixins: [ helpers, durations, binder, seen ],
  data () {
    return {
      seenLast: null,
      clientColors: {},
      subscribers: [],
    }
  },
  computed: {
    ...mapGetters(['_loader', '_badgeTotals', '_user']),
  },
  watch: {
    // contacts (v, ov) {
    //   if ((ov || []).length === 0 && (v || []).length > 0) {
    //     let timestamp = maxBy(v, 'timestamp').timestamp
    //     this._seenUpdate('contact', timestamp)
    //   }
    // }
  },
  beforeMount () {
    this.seenLast = this._seenLast('bulletin')
    this._seenWatch('contact', !this.$route.params.sub)
    this.bindSubscribers()
    this.$store.commit('set_appBarTitle', {title: 'Bulletin', icon: 'auto_stories'})
  },
  mounted () {
    this._seenUpdate('bulletin')
  },
  methods: {
    bindSubscribers () {
      this.$bindRtdb(
        'subscribers', 
        rtdb.ref(`webForms/bulletin`).orderByChild('timestamp'), 
        { callback: this.buildList, loader: true }
      )
    },
    buildList (subscribers) {
      this.subscribers = []
      forEach(subscribers, (c, id) => {
        let clientHash = window.btoa(c.email)
        if (!this.clientColors[clientHash]) this.clientColors[clientHash] = this._randomMaterialColor()

        c.color = this.clientColors[clientHash]
        c.name = `${c.firstName} ${c.lastName}`
        c.id = id
        c.initials = this._initials(`${c.firstName} ${c.lastName}`)
        this.subscribers.unshift(c)
      })
      this.subscribers = sortBy(subscribers, 'timestamp')
    },
    date(date) {
      return moment(date).format('DD-MMM-YYYY')
    },
    exportToCsv() {
    try {
      const fields = ['name', 'firstName', 'lastName', 'company', 'email', 'phone', 'address1', 'address2', 'city', 'province', 'postcode', 'source']
      const csv = parse(this.subscribers, { fields });
      this._exportToCsv(csv, 'Bulletin Subscribers.csv')
    } catch (err) {
      console.error(err);
    }
    },
    deleteSubscriber(subscriber) {
      rtdb.ref(`webForms/bulletin/${subscriber.id}`).set(null)
    }
  }
}
</script>
2/12/120
<style lang="css" scoped>

</style>
